export const DEFAULT_MARGIN = 8
export const DEFAULT_LENGTH = 0
export const LINE_ID = 'line'
